import { useMemo } from "react";
import type { MdIdentifier } from "@ptsd/uikit";

import type { RouterOutputs } from "~/utils/api";
import { constructDynamicsText } from "~/utils/construct-dynamics";
import {
  getDynamicsStatus,
  getStatusFromSphereLevel,
} from "~/utils/get-status";
import type { ComposedTextProps } from "~/component/feature";

type bySphereReturnType = RouterOutputs["scores"]["bySphere"];

export const useConstuctComposedText = (data: bySphereReturnType) => {
  const identifier = useMemo<MdIdentifier | undefined>(() => {
    if (data?.level?.level) {
      if (data.level.level === "CRITICAL") return "critical";
      if (data.level.level === "MIDDLE") return "warning";
      if (data.level.level === "HIGH") return "success";
      if (data.level.level === "RESOURCE") return "success";
    }
  }, [data?.level?.level]);

  const composedText = useMemo(() => {
    return {
      title: data?.title ?? "",
      image: data?.image ?? "",
      description: {
        md: data?.text ?? "",
        mdDomain: data?.domainDescription?.text ?? "",
      },
      identifier,
      score: Number.isNaN(data?.score) ? 0 : data?.score ?? 0,
      state: getStatusFromSphereLevel(data?.level?.level) as string,
      dynamics: {
        state: getDynamicsStatus(data.dynamic) ?? "",
        description: data?.level?.name ?? "",
        text: constructDynamicsText(data?.dynamic) ?? "",
      },
      isPaywall: data?.isPaywall ?? false,
    } satisfies ComposedTextProps;
  }, [data, identifier]);

  return composedText;
};
